module.exports = __webpack_public_path__ + "static/20-12-52fdf6e0da32b7083dacef8369370ba5.jpg";